import { weenatIntl } from '@weenat/wintl';
import isEmpty from 'lodash-es/isEmpty';
import isNil from 'lodash-es/isNil';
import { Brand } from '../../enums/Devices';
const COMMON_NAMES_WINTL_KEY = 'models.device.common_names';
export function getDeviceCommonName(device) {
    const { availableMeasures, endUserName } = device;
    let key;
    if (device.brand !== Brand.weenat) {
        switch (device.brand) {
            case Brand.adcon:
                key = 'adcon_station';
                break;
            case Brand.pessl:
                key = 'pessl_station';
                break;
            case Brand.davis:
                key = 'davis_station';
                break;
            case Brand.corhize:
                key = 'corhize_station';
                break;
            default:
                key = 'unknown_station';
                break;
        }
    }
    else {
        if (!isEmpty(availableMeasures)) {
            if (availableMeasures.length === 2 &&
                availableMeasures.includes('T') &&
                availableMeasures.includes('U')) {
                key = 'thermometer_hygrometer';
            }
            else if (availableMeasures.includes('FF') ||
                availableMeasures.includes('FXY') ||
                availableMeasures.includes('DD') ||
                availableMeasures.includes('DXY')) {
                key = 'anemometer';
            }
            else if (availableMeasures.includes('LW_D') || availableMeasures.includes('LW_V')) {
                key = 'leaf_wetness_sensor';
            }
            else if (availableMeasures.includes('T_WET') || availableMeasures.includes('T_DRY')) {
                key = 'frost_sensor';
            }
            else if (availableMeasures.includes('CAPA') || availableMeasures.includes('U_CAPA')) {
                key = 'capacitive_probe';
            }
            else if (availableMeasures.includes('HPOT') || availableMeasures.includes('T_CAL')) {
                key = 'tensiometer';
            }
            else if (availableMeasures.includes('PPFD')) {
                key = 'par_sensor';
            }
            else if (availableMeasures.includes('SSI')) {
                key = 'pyranometer';
            }
            else if (availableMeasures.includes('ECP') || availableMeasures.includes('SWC')) {
                key = 'fertigation_probe';
            }
            else if (availableMeasures.includes('T_SOIL')) {
                key = 'soil_thermometer';
            }
            else if (availableMeasures.includes('RR')) {
                key = 'weather_station';
            }
        }
    }
    return !isNil(key)
        ? weenatIntl.t(`${COMMON_NAMES_WINTL_KEY}.${key}`)
        : `${endUserName[0]} ${endUserName[1]}`;
}
